import { CSSProperties } from 'react';

import UIConfig from '@/UIConfig';

export const wrapperStyle: CSSProperties = {
  height: 'calc(100vh - 100px)',
  background: '#B676E5',
  overflowY: 'auto',
  overscrollBehavior: 'none',
  position: 'relative'
};

export const topStarContainerStyle: CSSProperties = {
  position: 'absolute',
  top: 70,
  right: 50
};

export const topCirclesWrapperStyle: CSSProperties = {
  position: 'absolute',
  bottom: '65vh',
  left: '50%',
  transform: 'translateX(-50%)',
  width: '1px',
  height: '1px',
  zIndex: 1
};

export const circle240Style: CSSProperties = {
  width: '240px',
  height: '240px',
  backgroundColor: '#FFF',
  opacity: 0.03,
  borderRadius: '50%',
  position: 'absolute',
  top: 0,
  left: 0,
  transform: 'translate(-50%, -50%)'
};

export const circle180Style: CSSProperties = {
  width: '180px',
  height: '180px',
  backgroundColor: '#FFF',
  opacity: 0.07,
  borderRadius: '50%',
  position: 'absolute',
  top: 0,
  left: 0,
  transform: 'translate(-50%, -50%)'
};

export const darkBlockWrapperStyle: CSSProperties = {
  position: 'absolute',
  bottom: 0,
  left: 0,
  width: '100%',
  height: '65vh',
  backgroundColor: UIConfig.Colors.BackgroundDark,
  borderTopLeftRadius: '50% 7%',
  borderTopRightRadius: '50% 7%',
  overflow: 'visible',
  zIndex: 2
};

export const darkStarWrapperStyle: CSSProperties = {
  position: 'absolute',
  top: 0,
  left: '50%',
  transform: 'translateX(-50%)',
  width: '1px',
  height: '1px'
};

export const darkStarOuterCircleStyle: CSSProperties = {
  width: '120px',
  height: '120px',
  background: UIConfig.Colors.BackgroundDark,
  borderRadius: '50%',
  position: 'absolute',
  top: 0,
  left: 0,
  transform: 'translate(-50%, -50%)'
};

export const darkStarInnerCircleStyle: CSSProperties = {
  width: '100px',
  height: '100px',
  background: UIConfig.Colors.GradientPremium,
  borderRadius: '50%',
  position: 'absolute',
  top: 0,
  left: 0,
  transform: 'translate(-50%, -50%)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
};

export const titleBlockStyle: CSSProperties = {
  marginTop: '60px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  padding: '0 20px'
};

export const titleTextStyle: CSSProperties = {
  color: '#FFF',
  fontWeight: 700,
  fontSize: '24px',
  marginBottom: '6px'
};

export const subtitleTextStyle: CSSProperties = {
  color: '#e0e0e0',
  margin: 0,
  padding: 0,
  fontWeight: 400,
  fontSize: '15px',
  letterSpacing: '0.3px',
  lineHeight: '1.4'
};

export const sliderWrapperStyle: CSSProperties = {
  marginTop: '25px',
  width: '100%',
  overflow: 'hidden',
  position: 'relative'
};

export const sliderTrackBaseStyle: CSSProperties = {
  display: 'flex',
  willChange: 'transform'
};

export const slideItemStyle: CSSProperties = {
  width: '100%',
  flexShrink: 0,
  padding: '20px',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '12px'
};

export const slideIconWrapperStyle: CSSProperties = {
  width: 50,
  height: 50,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  border: '2px solid #FDC93F',
  background: 'transparent'
};

export const slideTitleStyle: CSSProperties = {
  color: '#fff',
  marginTop: 10,
  fontSize: '20px',
  fontWeight: 600,
  textAlign: 'center'
};

export const slideSubtitleStyle: CSSProperties = {
  color: '#CBC8C8',
  marginTop: 10,
  fontSize: '14px',
  textAlign: 'center',
  lineHeight: 1.4,
  maxWidth: '250px'
};

export const dotsWrapperStyle: CSSProperties = {
  marginTop: '12px',
  display: 'flex',
  justifyContent: 'center',
  gap: '8px'
};

export const dotBaseStyle: CSSProperties = {
  borderRadius: '50%',
  transition: '0.2s',
  background: 'rgba(255,255,255,0.4)',
  width: '7px',
  height: '7px'
};

export const dotActiveStyle: CSSProperties = {
  borderRadius: '50%',
  width: '10px',
  height: '10px',
  marginTop: '-1.5px',
  background: '#fff'
};

export const mainButtonStyleStyle: CSSProperties = {
  background: UIConfig.Colors.GradientPremium,
  color: '#fff'
};

export const starInlineStyle: CSSProperties = {
  marginLeft: '4px',
  marginRight: '4px',
  display: 'inline-block',
  verticalAlign: 'middle',
  position: 'relative',
  top: '-2px'
};
